<template>
  <div class="media-info-com" v-show="mediaLoaded">
    <!-- 左侧媒体内容区域 -->
    <div class="m-i-c-left">
      <!-- 标题区域 -->
      <div class="media-name">
        <div class="m-n-info1">{{ currentMedia?.name }}</div>
        <div class="m-n-info2">
          <clock-circle-outlined />
          {{ currentMedia?.create_time }}
          {{ currentMedia?.size }}
        </div>
      </div>

      <!-- 左切换按钮 -->
      <div class="media-left-btn" @click="prevMedia">
        <left-outlined />
      </div>

      <!-- 右切换按钮 -->
      <div :class="['media-right-btn', { 'media-right-btn-full': isFullscreen }]" @click="nextMedia">
        <right-outlined />
      </div>
      <div class="load-mask-bg" v-show="viewLoading"></div>
      <div v-show="viewLoading" class="load-mask">
        <div class="css-1dowtov ant-spin ant-spin-lg ant-spin-spinning ant-spin-show-text loading">
          <span class="ant-spin-dot ant-spin-dot-spin">
            <i class="ant-spin-dot-item"></i>
            <i class="ant-spin-dot-item"></i>
            <i class="ant-spin-dot-item"></i>
            <i class="ant-spin-dot-item"></i>
          </span>
          <div class="ant-spin-text">图片加载中...</div>
        </div>
      </div>

      <!-- 媒体内容 -->
      <div v-if="mediaLoaded" class="media-content">
        <!-- 全景图容器 -->
        <div v-if="isPanorama" id="panorama" class="imgViewer-com"></div>

        <!-- 普通图片查看器 -->
        <div v-show="mediaType === 'image' && !isPanorama"
          :class="['imgViewer-com', { 'imgViewer-com-full': isFullscreen }]">
          <div id="imgViewer" v-if="currentMedia">
            <ul>
              <li v-for="(media) in [currentMedia]" :key="media.id">
                <img
                  :src=" showAnalysisImage && analysisUrl ? analysisUrl : getMediaSrc(media)"
                  :alt=" showAnalysisImage && analysisUrl ? media.fileName + '分析图' : media.fileName"
                  :data-original=" showAnalysisImage && analysisUrl ? analysisUrl : getMediaSrc(media)"
                  :style="{ 'display': 'none' }" />
              </li>
            </ul>
          </div>

          <div v-if="mediaType === 'image' && !isPanorama" class="analysis-float-layer">
            <div class="analysis-switch">
              <span class="analysis-label">目标检测:</span>
              <a-switch v-model:checked="analysisChecked" @change="handleAnalysisChange" :loading="analysisLoading" :disabled="viewLoading" size="small" class="ml10" />
            </div>

            <div class="analysis-switch" v-if="currentMedia && currentMedia.portion">
              <span class="analysis-label">隐患识别:</span>
              <a-switch v-model:checked="modelChecked" @change="handleModelChange" size="small" class="ml10" />
            </div>

            <!-- 分析结果弹框 -->
            <div v-if="analysisChecked" class="analysis-results-popup">
              <div class="analysis-results-header">
                <span>分析结果</span>
                <close-outlined class="close-icon" @click="closeAnalysisResults" />
              </div>
              <div v-if="analysisLoading" class="analysis-loading">
                <a-spin tip="分析结果加载中..." size="small" />
              </div>
              <div v-else class="analysis-results-content">
                <div v-if="analysisResults && analysisResults.length > 0" class="analysis-items">
                  <div v-for="(item, index) in analysisResults" :key="index" class="analysis-item">
                    <span class="analysis-name">{{ item.name || item.type }}：</span>
                    <span class="analysis-count">{{ item.count || '0' }}</span>
                  </div>
                </div>
                <div v-else-if="analysisMessage" class="no-analysis-results">
                  <span>当前无分析结果</span>
                </div>
                <div v-else-if="analysisError" class="analysis-error">
                  <span>分析图加载失败</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 视频查看器 -->
        <div v-if="mediaType === 'video'" :class="['videoViewer-com', { 'videoViewer-com-full': isFullscreen }]">
          <video id="videoViewer" class="video-player" ref="videoPlayer" :controls="false" preload="metadata" @play="onVideoPlay"
            @pause="onVideoPause" @ended="onVideoEnded" @timeupdate="onVideoTimeUpdate"
            @loadedmetadata="onVideoLoadedMetadata">
            <source :src="currentMedia?.url" :type="getVideoMimeType(currentMedia)" />
            您的浏览器不支持视频播放。
          </video>
        </div>

        <!-- 操作区域 -->
        <div :class="['media-operate', { 'media-operate-full': isFullscreen }]">
          <div class="total-page-box">
            <div class="total-page-num">第 {{ page.currentPage }} 页</div>
            <div class="total-page-size">共 {{ page.totalPage }} 页</div>
          </div>
          <!-- 图片操作按钮 -->
          <div v-if="mediaType === 'image' && !isPanorama" class="m-o-btn-list">
            <div class="btn-li" @click="viewerZoomIn">
              <i class="iconfont icon-zoom-in"></i>
            </div>
            <div class="btn-li" @click="viewerZoomOut">
              <i class="iconfont icon-zoom-out"></i>
            </div>
            <div class="btn-li" @click="viewerResetZoom">1:1</div>
            <div class="btn-li" @click="viewerRotateLeft">
              <i class="iconfont icon-rotate-left"></i>
            </div>
            <div class="btn-li" @click="toggleFullscreen">
              <i class="iconfont icon-full-screen"></i>
            </div>
            <!-- <div class="btn-li" @click="openSplitScreen">
              <i class="iconfont icon-split-screen"></i>
            </div> -->
            <div v-hasPermi="['media:status']" class="btn-li" @click="toggleMapDisplay">
              <i :class="['iconfont', showMapStatus ? 'icon-map-off' : 'icon-map-on']"></i>
            </div>
          </div>

          <!-- 全景图操作按钮 -->
          <div v-if="isPanorama" class="m-o-btn-list">
            <div class="btn-li" @click="panoramaZoomIn">
              <i class="iconfont icon-zoom-in"></i>
            </div>
            <div class="btn-li" @click="panoramaZoomOut">
              <i class="iconfont icon-zoom-out"></i>
            </div>
            <div class="btn-li" @click="panoramaResetZoom">1:1</div>
            <div class="btn-li" @click="panoramaRotateLeft">
              <i class="iconfont icon-rotate-left"></i>
            </div>
            <div class="btn-li" @click="toggleFullscreen">
              <i class="iconfont icon-full-screen"></i>
            </div>
            <div class="btn-li" @click="openSplitScreen">
              <i class="iconfont icon-split-screen"></i>
            </div>
            <div v-hasPermi="['media:status']" class="btn-li" @click="toggleMapDisplay">
              <i :class="['iconfont', showMapStatus ? 'icon-map-off' : 'icon-map-on']"></i>
            </div>
          </div>

          <!-- 视频操作按钮 -->
          <div v-if="mediaType === 'video'" class="m-o-btn-list">
            <div class="btn-li" @click="toggleVideoPlay">
              <i :class="['iconfont', isVideoPlaying ? 'icon-icon-pause' : 'icon-play']"></i>
            </div>
            <div class="btn-li" @click="toggleFullscreen">
              <i class="iconfont icon-full-screen"></i>
            </div>
          </div>

          <!-- 视频进度条 -->
          <div v-if="mediaType === 'video'" class="video-progress-container">
            <div class="video-progress-bar" ref="progressBar" @click="onProgressBarClick">
              <div class="video-progress" :style="{ width: videoProgress + '%' }"></div>
              <div class="video-progress-handle" :style="{ left: videoProgress + '%' }"></div>
            </div>
            <div class="video-time">
              <span>{{ formatVideoTime(currentVideoTime) }}</span> /
              <span>{{ formatVideoTime(videoDuration) }}</span>
            </div>
          </div>

          <!-- 缩略图列表 -->
          <div v-if="!isFullscreen" class="m-o-img-list">
            <!-- 左切换按钮 -->
            <div v-show="page.currentPage > 1" class="media-left-btn" @click="prevPage">
              <left-outlined />
            </div>
            <div class="img-list-content">
              <div v-for="(media, index) in mediaList" :key="index" :class="['img-preview', {
                'active': currentMediaIndex === index,
                'video-preview': !isImage(media),
                'panorama-preview': media.panorama
              }]" @click="switchMedia(index)">
                <img :id="`media_img_${index}`" :src="getThumbnailSrc(media)" :alt="media.fileName" loading="lazy"
                  width="84" height="72" />
                <div class="img-tips" v-if="media.analysis_result">
                  <SvgIcon name="AIshibie" :style="{color: '#ffffff', fontSize: '20px'}"/>
                </div>
                <div v-if="!isImage(media)" class="panorama-badge">
                  <i class="iconfont icon-play"></i>
                </div>
              </div>
            </div>
            <!-- 右切换按钮 -->
            <div v-show="page.currentPage !== page.totalPage" :class="['media-right-btn', { 'media-right-btn-full': isFullscreen }]" @click="nextPage">
              <right-outlined />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧详情信息区域 -->
    <div class="m-i-c-right" v-if="!isFullscreen">
      <!-- 关闭按钮 -->
      <div class="m-i-c-close" @click="closeMediaInfo">
        <close-outlined class="icon_close" />
      </div>

      <!-- 详细信息 -->
      <div class="detail-info">
        <div class="d-i-title">详细信息</div>

        <!-- 视频信息 -->
        <div v-if="mediaType === 'video'" class="video-info">
          <div class="d-i-dataList">
            <div class="dataList-key">视频名称</div>
            <!-- 编辑名称 -->
            <div v-if="isEditingName" class="d-i-dataList">
              <div class="dataList-val d-a-name">
                <input v-model="editName" type="text" class="name-input" @keyup.enter="saveEditName"
                  @blur="cancelEditName" ref="nameInputRef" :maxlength="32" />
                <span class="name-edit-btn">
                  <check-outlined class="icon_check" @click="saveEditName" />
                  <close-outlined class="icon_close" @click="cancelEditName" />
                </span>
              </div>
            </div>
            <div v-else class="dataList-val d-a-name">
              <span class="name">{{ currentMedia?.name || currentMedia?.file_name }}</span>
              <span v-hasPermi="['media:favorites']" class="name-edit-btn" @click="startEditName">
                <edit-outlined class="icon_edit" />
              </span>
            </div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">经度</div>
            <div class="dataList-val">{{ Number(currentMedia?.lon).toFixed(6) || '--' }}</div>
          </div>
          <div class="d-i-dataList">
            <div class="dataList-key">纬度</div>
            <div class="dataList-val">{{ Number(currentMedia?.lat).toFixed(6) || '--' }}</div>
          </div>

          <div class="d-i-dataList" v-show="currentMedia?.ext?.duration">
            <div class="dataList-key">视频时长</div>
            <div class="dataList-val">{{ formatDuration(currentMedia?.ext?.duration) }}</div>
          </div>

          <div class="d-i-dataList" v-show="currentMedia?.resolution">
            <div class="dataList-key">视频分辨率</div>
            <div class="dataList-val">{{ currentMedia?.resolution || '--' }}</div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">视频大小</div>
            <div class="dataList-val">{{ currentMedia?.size || '--' }}</div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">拍摄负载</div>
            <div class="dataList-val">{{ currentMedia?.payload || '--' }}</div>
          </div>

          <!-- <div class="d-i-dataList">
            <div class="dataList-key">文件来源</div>
            <div class="dataList-val">{{ currentMedia?.createBy || '--' }}</div>
          </div> -->

          <div class="d-i-dataList" v-show="currentMedia?.ext?.shootTime">
            <div class="dataList-key">拍摄时间</div>
            <div class="dataList-val">{{ formatTime(currentMedia?.ext?.shootTime) }}</div>
          </div>

          <!-- <div class="d-i-dataList">
            <div class="dataList-key">标签</div>
            <div class="dataList-val">
              <span
                v-for="tag in currentMedia?.tagList"
                :key="tag.id"
                class="icon-tag-item"
              >
                {{ tag.tagName }}
              </span>
              <span v-if="!currentMedia?.tagList?.length" class="no-tag">--</span>
            </div>
          </div> -->
        </div>

        <!-- 图片信息（包括全景图） -->
        <div v-else class="img-info">
          <div class="d-i-dataList">
            <div class="dataList-key">照片名称</div>
            <!-- 编辑名称 -->
            <div v-if="isEditingName" class="d-i-dataList">
              <div class="dataList-val d-a-name">
                <input v-model="editName" type="text" class="name-input" @keyup.enter="saveEditName"
                  @blur="cancelEditName" ref="nameInputRef" :maxlength="32" />
                <span class="name-edit-btn">
                  <check-outlined class="icon_check" @click="saveEditName" />
                  <close-outlined class="icon_close" @click="cancelEditName" />
                </span>
              </div>
            </div>
            <div v-else class="dataList-val d-a-name">
              <span class="name">{{ currentMedia?.name || currentMedia?.file_name }}</span>
              <span v-hasPermi="['media:edit']" class="name-edit-btn" @click="startEditName">
                <edit-outlined class="icon_edit" />
              </span>
            </div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">照片类型</div>
            <div class="dataList-val">{{ getImageTypeText(currentMedia) }}</div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">经度</div>
            <div class="dataList-val">{{ Number(currentMedia?.lon).toFixed(6) || '--' }}</div>
          </div>
          <div class="d-i-dataList">
            <div class="dataList-key">纬度</div>
            <div class="dataList-val">{{ Number(currentMedia?.lat).toFixed(6) || '--' }}</div>
          </div>
          <div class="d-i-dataList" v-show="currentMedia?.absolute_altitude">
            <div class="dataList-key">海拔高度</div>
            <div class="dataList-val">{{ currentMedia?.absolute_altitude + ' m' || '--' }}</div>
          </div>
          <div class="d-i-dataList" v-show="currentMedia?.resolution">
            <div class="dataList-key">照片分辨率</div>
            <div class="dataList-val">{{ currentMedia?.resolution || '--' }}</div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">照片大小</div>
            <div class="dataList-val">{{ currentMedia?.size || '--' }}</div>
          </div>

          <div class="d-i-dataList">
            <div class="dataList-key">拍摄负载</div>
            <div class="dataList-val">{{ currentMedia?.payload || '--' }}</div>
          </div>

          <!-- <div class="d-i-dataList">
            <div class="dataList-key">文件来源</div>
            <div class="dataList-val">{{ currentMedia?.createBy || '--' }}</div>
          </div> -->

          <div class="d-i-dataList">
            <div class="dataList-key">拍摄时间</div>
            <div class="dataList-val">{{ currentMedia?.create_time || '--' }}</div>
          </div>

          <!-- <div class="d-i-dataList">
            <div class="dataList-key">标签</div>
            <div class="dataList-val">
              <span
                v-for="tag in currentMedia?.tagList"
                :key="tag.id"
                class="icon-tag-item"
              >
                {{ tag.tagName }}
              </span>
              <span v-if="!currentMedia?.tagList?.length" class="no-tag">--</span>
            </div>
          </div> -->
        </div>

        <!-- 操作按钮 -->
        <div class="detail-btn">
          <!-- 收藏按钮 -->
          <div v-hasPermi="['media:favorites']" class="d-b-li" @click="toggleFavorite">
            <i :class="['iconfont', currentMedia?.favorites ? 'icon-shoucang' : 'icon-weishoucang']"></i>
            <div class="btn-txt">{{ currentMedia?.favorites ? '取消收藏' : '收藏' }}</div>
          </div>

          <!-- 标签按钮 -->
          <!-- <div class="d-b-li" @click="openLabelModal">
            <i class="iconfont icon-tag"></i>
            <div class="btn-txt">标签</div>
          </div> -->

          <!-- 下载按钮 -->
          <div v-hasPermi="['media:download']" class="d-b-li" @click="downloadMedia">
            <i class="iconfont icon-download"></i>
            <div class="btn-txt">{{ downloading ? '下载中...' : '下载' }}</div>
          </div>

          <!-- 删除按钮 -->
          <!-- <div class="d-b-li" @click="openDeleteModal">
            <i class="iconfont icon-delete"></i>
            <div class="btn-txt">删除</div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 分屏对比模态框 -->
    <media-contrast v-if="showContrast" :origin-img="originImage" :origin-img-id="originImageId"
      :origin-img-name="originImageName" @close="closeContrast" />

    <!-- 标签设置模态框 -->
    <div v-if="showLabelModal" class="label-modal-overlay" @click.self="closeLabelModal">
      <div class="label-modal">
        <div class="modal-header">
          <h3 class="modal-title">标签设置</h3>
          <button class="btn-close" @click="closeLabelModal">
            <i class="iconfont icon_close"></i>
          </button>
        </div>

        <div class="modal-content">
          <div class="current-media-info">
            <div class="media-thumb">
              <img :src="currentMedia?.thumbnailsUrl" :alt="currentMedia?.fileName" />
            </div>
            <div class="media-details">
              <h4 class="media-name">{{ currentMedia?.fileName }}</h4>
              <div class="media-type">{{ getMediaType(currentMedia) }}</div>
            </div>
          </div>

          <div class="label-form">
            <div class="form-group">
              <label class="form-label">添加标签</label>
              <div class="tag-input-container">
                <input type="text" v-model="newTag" class="tag-input" placeholder="输入标签名称" @keyup.enter="addNewTag" />
                <button class="btn-add-tag" @click="addNewTag">
                  <i class="iconfont icon_plus"></i>
                </button>
              </div>
            </div>

            <div class="suggested-tags">
              <div class="section-title">推荐标签</div>
              <div class="tag-list">
                <button v-for="tag in suggestedTags" :key="tag" class="tag-item suggested" @click="addTag(tag)">
                  {{ tag }}
                </button>
              </div>
            </div>

            <div class="selected-tags">
              <div class="section-title">已选标签</div>
              <div class="tag-list" v-if="selectedTags.length > 0">
                <div v-for="tag in selectedTags" :key="tag" class="tag-item selected">
                  {{ tag }}
                  <button class="tag-remove" @click="removeTag(tag)">
                    <i class="iconfont icon_close_small"></i>
                  </button>
                </div>
              </div>
              <div v-else class="empty-tags">暂无标签</div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-cancel" @click="closeLabelModal">取消</button>
          <button class="btn btn-save" @click="saveLabels" :disabled="isSaving">
            <span v-if="isSaving">保存中...</span>
            <span v-else>保存</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 删除确认模态框 -->
    <deleteConfirm v-model:open="showDeleteModal" :mediaName="currentMedia?.name" @confirm="confirmDelete"
      @cancel="closeDeleteModal"></deleteConfirm>

    <!-- 算法分析弹窗 -->
    <a-modal v-model:visible="algoMediaAnalysisVisible" title="媒体分析" centered :zIndex="1000" :footer="null" @cancel="handleCloseAlgoMediaAnalysis" >
      <div class="algo-analysis-form">
        <div class="form-item">
          <div class="form-label">算法</div>
          <div class="form-control">
            <a-select v-model:value="formAlgoAnalysisData.algorithmId" placeholder="请选择算法" :dropdownMatchSelectWidth="false" >
              <a-select-option v-for="item in algorithmDataList" :key="item.id" :value="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">置信度</div>
          <div class="form-control">
            <a-input-number v-model:value="formAlgoAnalysisData.confidence" :min="0.1" :max="1.0" :step="0.1" style="width: 100%" />
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <a-tooltip title="同时进行大模型分析">
              <QuestionCircleOutlined class="c189 ml5" />
            </a-tooltip>
            <span>大模型</span>
          </div>
          <div class="form-control">
            <a-radio-group v-model:value="formAlgoAnalysisData.enableLargeModel">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="form-actions">
          <a-button @click="handleCloseAlgoMediaAnalysis">关闭</a-button>
          <a-button type="primary" :loading="submitAlgoAnalysisLoading" @click="toggleAlgoAnalysis" >
            分析
          </a-button>
        </div>
      </div>
    </a-modal>

    <AnalysisResultModal
      v-model:visible="modelModalVisible"
      :record="currentMedia"
      @saved="onAnalysisSaved"
    />
  </div>
</template>

<script setup lang="ts">
import { message } from 'ant-design-vue'
import { ref, computed, onMounted, onUnmounted, watch, nextTick, defineProps, defineEmits, defineExpose, reactive } from 'vue'
import { Viewer } from '@photo-sphere-viewer/core'
import '@photo-sphere-viewer/core/index.css'
import MediaContrast from './media-contrast.vue'
import deleteConfirm from './delete-confirm.vue'
import ImageViewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import { getMediaFileAnalysis } from '/@/api/algCode'
import { getSubsetPage, downloadMediaFile, downloadWatermarkMediaFile } from '/@/api/media'
import { downloadFile } from '/@/utils/common'
import { ELocalStorageKey } from '/@/types'
import { getAllAlgList } from '/@/api/insp-algorithm'
import { getAlgoAnalysisResult } from '/@/api/insp/insp-media'
import AnalysisResultModal from '../media/AnalysisResultModal.vue'

const props = defineProps({
  tagOptions: {
    type: Array,
    default: () => []
  },
  workspaceId: {
    type: String,
    default: ''
  },
  selectFolderId: {
    type: String,
    default: ''
  },
  folderName: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['closeMediaInfo', 'updateMediaFileList', 'toggleDisplay'])

// 响应式数据
const mediaList = ref([])
const currentMediaIndex = ref(0)
const mediaType = ref('image')
const isFullscreen = ref(false)
const isPanorama = ref(false)
const mediaLoaded = ref(false)
const showMapStatus = ref(false)
const showContrast = ref(false)
const originImage = ref('')
const originImageId = ref('')
const originImageName = ref('')
const viewLoading = ref(false)

// 视频相关
const videoPlayer = ref(null)
const isVideoPlaying = ref(false)
const isVideoMuted = ref(false)
const videoDuration = ref(0)
const currentVideoTime = ref(0)
const videoProgress = ref(0)
const progressBar = ref(null)

// 编辑相关
const isEditingName = ref(false)
const editName = ref('')
const nameInputRef = ref(null)

// 标签相关
const showLabelModal = ref(false)
const newTag = ref('')
const selectedTags = ref([])
const isSaving = ref(false)

// 删除相关
const showDeleteModal = ref(false)

// 全景图查看器实例
const panoramaViewer = ref(null)
// Viewer.js 图片查看器实例
const viewerInstance = ref(null)

// 计算属性
const currentMedia = computed(() => {
  return mediaList.value[currentMediaIndex.value] || null
})

const suggestedTags = computed(() => {
  return props.tagOptions.filter(tag =>
    !selectedTags.value.includes(tag) &&
    (!newTag.value || tag.toLowerCase().includes(newTag.value.toLowerCase()))
  ).slice(0, 10)
})

// 图片类型常量
const IMAGE_TYPES = [
  '未知', '截屏图', '广角', '红外', '变焦', '可见光广角',
  '绿', '红', '红边', '近红外', '可见光RGB', 'NDVI',
  '全景图', '其他图片', '告警图片'
]

const isImage = (record) => {
  if (record && !record.file_type) return false
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
  return imageTypes.includes(record.file_type.toLowerCase())
}
const page = reactive({
  currentPage: 1,
  pageSize: 5,
  totalPage: 1,
  totalCount: 0
})

const getPageMedia = async () => {
  destroyPanoramaViewer()
  destroyImageViewer()
  const queryParam = {
    page: page.currentPage,
    page_size: page.pageSize,
    param: {
      folder_name: props.folderName
    }
  }
  const res = await getSubsetPage(props.workspaceId, props.selectFolderId, queryParam)
  if (res && res.code === 0) {
    mediaList.value = []
    nextTick(() => {
      mediaList.value = res.data.list
      currentMediaIndex.value = 0
      mediaType.value = isImage(mediaList.value[0]) ? 'image' : 'video'
    })
    page.totalCount = res.data.pagination.total
    page.totalPage = res.data.pagination.total ? Math.ceil(page.totalCount / page.pageSize) : 1
  } else {
    mediaList.value = []
    page.totalPage = 1
  }
  mediaLoaded.value = true

  // 检查是否为全景图
  const media = currentMedia.value
  isPanorama.value = media?.panorama
  showMapStatus.value = media?.map_load
  // 初始化对应的查看器
  nextTick(() => {
    if (isPanorama.value) {
      initPanoramaViewer(media.url)
    } else if (mediaType.value === 'image') {
      // 初始化图片查看器
      initImageViewer()
    } else if (mediaType.value === 'video') {
      // 初始化视频播放器
      initVideoPlayer()
    }
  })
}
// 初始化数据
const initData = async (mediaArray, startIndex, workspace_id, folderId, currentPage, name, record) => {
  page.currentPage = Math.ceil(startIndex / page.pageSize) || 1
  mediaList.value = []
  const queryParam = {
    page: page.currentPage,
    page_size: page.pageSize,
    param: {
      folder_name: name
    }
  }
  const id = workspace_id || props.workspaceId
  const folder_id = folderId || props.selectFolderId
  const res = await getSubsetPage(id, folder_id, queryParam)
  if (res && res.code === 0) {
    mediaList.value = res.data.list
    page.totalCount = res.data.pagination.total
    page.totalPage = res.data.pagination.total ? Math.ceil(page.totalCount / page.pageSize) : 1
  } else {
    mediaList.value = []
    page.totalPage = 1
  }
  const index = mediaList.value.findIndex(item => item.id === record?.id)
  if (index > -1) {
    currentMediaIndex.value = index
    mediaType.value = isImage(mediaList.value[index]) ? 'image' : 'video'
  }
  mediaLoaded.value = true

  // 检查是否为全景图
  const media = currentMedia.value
  isPanorama.value = media?.panorama
  showMapStatus.value = media?.map_load
  // 初始化对应的查看器
  nextTick(() => {
    if (isPanorama.value) {
      initPanoramaViewer(media.url)
    } else if (mediaType.value === 'image') {
      // 初始化图片查看器
      initImageViewer()
    } else if (mediaType.value === 'video') {
      // 初始化视频播放器
      initVideoPlayer()
    }
  })
}

/**
 * 初始化全景图查看器
 * @param {string} panoramaUrl - 全景图片的URL地址
 */
const initPanoramaViewer = (panoramaUrl) => {
  destroyPanoramaViewer()

  viewLoading.value = true

  nextTick(() => {
    const container = document.getElementById('panorama')
    if (!container) return

    try {
      panoramaViewer.value = new Viewer({
        container: container,
        panorama: panoramaUrl,
        navbar: [],
        size: { width: '100%', height: '100%' },
        defaultZoomLvl: 50,
        minFov: 30,
        maxFov: 90,
        moveSpeed: 1,
        zoomSpeed: 1,
        moveInertia: true,
        mousewheel: true,
        mousemove: true,
        keyboard: true,
        touchmove: true,
        lang: {
          zoom: '缩放',
          zoomOut: '缩小',
          zoomIn: '放大',
          moveUp: '向上移动',
          moveDown: '向下移动',
          moveLeft: '向左移动',
          moveRight: '向右移动',
          download: '下载',
          fullscreen: '全屏',
          menu: '菜单',
          twoFingers: '用两个手指导航',
          ctrlZoom: '使用 ctrl + 滚轮放大',
          loadError: '图片加载失败'
        }
      })

      // 设置光标
      panoramaViewer.value.setCursor('grab')

      // 隐藏导航栏
      setTimeout(() => {
        const navbar = container.querySelector('.psv-navbar')
        if (navbar) navbar.style.display = 'none'
      }, 100)
      viewLoading.value = false
    } catch (error) {
      console.error('全景图初始化失败:', error)
      viewLoading.value = false
    }
  })
}

const initImageViewer = () => {
  destroyImageViewer()
  nextTick(() => {
    const container = document.getElementById('imgViewer')
    if (!container) {
      console.error('找不到 imgViewer 容器')
      return
    }

    const images = Array.from(container.querySelectorAll('img'))
    if (!images.length) {
      console.error('没有找到图片元素')
      return
    }

    try {
      if (!viewerInstance.value) {
        console.log('开始初始化 Viewer.js，图片数量:', images.length)
        viewLoading.value = true
        // 初始化 Viewer.js
        viewerInstance.value = new ImageViewer(container, {
          // 基本配置
          inline: true, // 内联模式
          navbar: false, // 隐藏导航栏
          title: false, // 隐藏标题
          toolbar: false, // 隐藏工具栏，我们使用自己的按钮
          rotatable: true, // 允许旋转
          scalable: true, // 允许缩放
          zoomable: true, // 允许缩放
          movable: true, // 允许移动
          keyboard: true, // 启用键盘控制

          // 过渡效果
          transition: false,

          // 缩放相关
          zoomRatio: 0.1,
          minZoomRatio: 0.01,
          maxZoomRatio: 100,
          // url: mediaList.value[currentMediaIndex.value].url,

          // 初始显示图片
          initialViewIndex: 0,

          // 事件回调
          ready: function (e) {
            console.log('Viewer.js 已加载')
            // 确保显示当前图片
            viewerInstance.value.view(0)
          },

          show: function (e) {
            console.log('显示图片:', e.detail.index)
          },

          viewed: function (e) {
            console.log('查看图片:', e.detail.index)
            // 更新当前索引
            // currentMediaIndex.value = 0
            viewLoading.value = false
          }
        })
        console.log('Viewer.js 初始化成功:', viewerInstance.value)
      } else {
        viewerInstance.value.view(currentMediaIndex.value)
      }
    } catch (error) {
      console.error('初始化图片查看器失败:', error)
      // 降级方案：直接显示图片
      showCurrentImage()
    }
  })
}
/**
 * 显示当前图片（Viewer.js 降级方案）
 */
const showCurrentImage = () => {
  const container = document.getElementById('imgViewer')
  if (!container) return

  const images = container.querySelectorAll('img')
  images.forEach((img, index) => {
    if (index === currentMediaIndex.value) {
      img.style.display = 'block'
    } else {
      img.style.display = 'none'
    }
  })
}

/**
 * 销毁图片查看器
 */
const destroyImageViewer = () => {
  if (viewerInstance.value) {
    viewerInstance.value.destroy()
    viewerInstance.value = null

    // 清理残留的DOM元素
    const container = document.getElementById('imgViewer')
    if (container) {
      const oldContainers = container.querySelectorAll('.viewer-container')
      oldContainers.forEach(el => el.remove())
    }
  }
}

/**
 * 初始化视频播放器
 */
const initVideoPlayer = () => {
  const videoElement = videoPlayer.value
  if (!videoElement) return

  // 重置视频状态
  isVideoPlaying.value = false
  isVideoMuted.value = false
  videoDuration.value = 0
  currentVideoTime.value = 0
  videoProgress.value = 0

  // 设置视频源
  if (currentMedia.value?.url) {
    videoElement.src = currentMedia.value.url
  }
}

// 视频事件处理
const onVideoPlay = () => {
  isVideoPlaying.value = true
}

const onVideoPause = () => {
  isVideoPlaying.value = false
}

const onVideoEnded = () => {
  isVideoPlaying.value = false
  currentVideoTime.value = videoDuration.value
  videoProgress.value = 100
}

const onVideoTimeUpdate = () => {
  const video = videoPlayer.value
  if (video) {
    currentVideoTime.value = video.currentTime
    videoDuration.value = video.duration || 0
    if (videoDuration.value > 0) {
      videoProgress.value = (currentVideoTime.value / videoDuration.value) * 100
    }
  }
}

const onVideoLoadedMetadata = () => {
  const video = videoPlayer.value
  if (video) {
    videoDuration.value = video.duration || 0
  }
}

// 视频控制方法
const toggleVideoPlay = () => {
  const video = videoPlayer.value
  if (!video) return

  if (video.paused) {
    video.play().catch(error => {
      console.error('播放视频失败:', error)
    })
  } else {
    video.pause()
  }
}

const toggleVideoMute = () => {
  const video = videoPlayer.value
  if (!video) return

  video.muted = !video.muted
  isVideoMuted.value = video.muted
}

// 进度条点击事件
const onProgressBarClick = (event) => {
  const video = videoPlayer.value
  if (!video || !progressBar.value || videoDuration.value <= 0) return

  const rect = progressBar.value.getBoundingClientRect()
  const clickPosition = event.clientX - rect.left
  const percentage = (clickPosition / rect.width) * 100
  const newTime = (percentage / 100) * videoDuration.value

  video.currentTime = newTime
  currentVideoTime.value = newTime
  videoProgress.value = percentage
}

/**
 * 切换当前显示的媒体内容
 *
 * @param {number} index - 媒体列表中的索引位置
 */
const switchMedia = async (index) => {
  const media = mediaList.value[index]
  if (!media) return

  // 重置分析状态
  analysisChecked.value = false
  analysisUrl.value = ''
  analysisResults.value = []
  analysisMessage.value = false
  analysisError.value = false

  modelChecked.value = false
  modelModalVisible.value = false

  currentMediaIndex.value = index
  mediaType.value = isImage(media) ? 'image' : 'video'
  isPanorama.value = media.panorama
  showMapStatus.value = media.map_load

  if (isPanorama.value) {
    if (panoramaViewer.value) {
      panoramaViewer.value.setPanorama(media.url, { showLoader: true })
    } else {
      initPanoramaViewer(media.url)
    }
  } else {
    destroyPanoramaViewer()

    if (mediaType.value === 'image') {
      // 切换到图片
      await nextTick()
      initImageViewer()
    } else if (mediaType.value === 'video') {
      // 切换到视频
      await nextTick()
      initVideoPlayer()
    }
  }
}

const prevPage = () => {
  if (page.currentPage === 1) {
    message.info('已经是第一页了')
  } else {
    page.currentPage--
    getPageMedia()
  }
}

const nextPage = () => {
  if (page.currentPage === page.totalPage) {
    message.info('已经是最后一页了')
  } else {
    page.currentPage++
    getPageMedia()
  }
}

// 上一个媒体
const prevMedia = () => {
  if (currentMediaIndex.value === 0) {
    currentMediaIndex.value = mediaList.value.length - 1
  } else {
    currentMediaIndex.value--
  }
  switchMedia(currentMediaIndex.value)
}

// 下一个媒体
const nextMedia = () => {
  if (currentMediaIndex.value === mediaList.value.length - 1) {
    currentMediaIndex.value = 0
  } else {
    currentMediaIndex.value++
  }
  switchMedia(currentMediaIndex.value)
}

// 关闭媒体信息
const closeMediaInfo = () => {
  // 重置分析状态
  analysisChecked.value = false
  analysisUrl.value = ''
  analysisResults.value = []
  analysisMessage.value = false
  analysisError.value = false

  mediaLoaded.value = false
  emit('closeMediaInfo')
  destroyPanoramaViewer()
  destroyImageViewer()
}

/**
 * 销毁全景图查看器实例并释放资源
 */
const destroyPanoramaViewer = () => {
  if (panoramaViewer.value) {
    panoramaViewer.value.destroy()
    panoramaViewer.value = null
  }
}

// 全景图操作方法
const panoramaZoomIn = () => {
  if (panoramaViewer.value) {
    const currentZoom = panoramaViewer.value.getZoomLevel()
    if (currentZoom >= 100) {
      console.warn('全景图已升到最大缩放级别')
      return false
    }
    panoramaViewer.value.zoomIn(5)
    return true
  }
  return false
}

const panoramaZoomOut = () => {
  if (panoramaViewer.value) {
    const currentZoom = panoramaViewer.value.getZoomLevel()
    if (currentZoom <= 0) {
      console.warn('全景图已降到最小缩放级别')
      return false
    }
    panoramaViewer.value.zoomOut(5)
    return true
  }
  return false
}

const panoramaResetZoom = () => {
  if (panoramaViewer.value) {
    panoramaViewer.value.zoom(0)
  }
}

const panoramaRotateLeft = () => {
  if (panoramaViewer.value) {
    const position = panoramaViewer.value.getPosition()
    position.yaw -= 90
    panoramaViewer.value.animate({
      yaw: position.yaw,
      pitch: position.pitch,
      speed: 1000
    })
  }
}

// 普通图片操作方法（Viewer.js）
const viewerZoomIn = () => {
  if (viewerInstance.value) {
    viewerInstance.value.zoom(0.1)
  }
}

const viewerZoomOut = () => {
  if (viewerInstance.value) {
    viewerInstance.value.zoom(-0.1)
  }
}

const viewerResetZoom = () => {
  if (viewerInstance.value) {
    viewerInstance.value.reset()
  }
}

const viewerRotateLeft = () => {
  if (viewerInstance.value) {
    viewerInstance.value.rotate(-90)
  }
}

// 全屏切换
const toggleFullscreen = () => {
  if (isPanorama.value && panoramaViewer.value) {
    panoramaViewer.value.toggleFullscreen()
    // } else if (mediaType.value === 'image' && viewerInstance.value) {
    //   // Viewer.js 全屏
    //   viewerInstance.value.full()
    // } else if (mediaType.value === 'video' && videoPlayer.value) {
    //   // 视频全屏
    //   if (!document.fullscreenElement) {
    //     videoPlayer.value.requestFullscreen?.()
    //   } else {
    //     document.exitFullscreen?.()
    //   }
  } else {
    // 组件全屏
    isFullscreen.value = !isFullscreen.value
    // if (isFullscreen.value) {
    //   document.documentElement.requestFullscreen?.()
    // } else {
    //   document.exitFullscreen?.()
    // }
  }
}

// 地图显示切换
const toggleMapDisplay = () => {
  emit('toggleDisplay', currentMedia.value, !showMapStatus.value, 'map_load', () => {
    currentMedia.value.map_load = !currentMedia.value.map_load
    showMapStatus.value = !showMapStatus.value
  })
  console.log('地图显示状态:', showMapStatus.value)
}

// 打开分屏对比
const openSplitScreen = () => {
  const media = currentMedia.value
  if (media && mediaType.value === 'image') {
    originImage.value = media.url
    originImageId.value = media.id
    originImageName.value = media.name
    showContrast.value = true
  }
}

const closeContrast = () => {
  showContrast.value = false
}

// 编辑名称
const startEditName = () => {
  isEditingName.value = true
  editName.value = currentMedia.value?.name || ''

  nextTick(() => {
    nameInputRef.value?.focus()
  })
}

const saveEditName = async () => {
  if (!editName.value.trim()) return

  try {
    console.log('更新文件名:', editName.value)
    emit('toggleDisplay', currentMedia.value, editName.value, 'name', () => {
      isEditingName.value = false
      currentMedia.value.name = editName.value
    })
  } catch (error) {
    console.error('更新文件名失败:', error)
  }
}

const cancelEditName = () => {
  isEditingName.value = false
  editName.value = ''
}

// 收藏操作
const toggleFavorite = async () => {
  try {
    console.log('切换收藏状态')
    emit('toggleDisplay', currentMedia.value, !currentMedia.value?.favorite, 'favorites', () => {
      currentMedia.value.favorite = !currentMedia.value?.favorite
    })
  } catch (error) {
    console.error('更新收藏状态失败:', error)
  }
}

// 标签操作
const openLabelModal = () => {
  selectedTags.value = [...(currentMedia.value?.tagList?.map(tag => tag.tagName) || [])]
  showLabelModal.value = true
}

const closeLabelModal = () => {
  showLabelModal.value = false
  newTag.value = ''
}

const addNewTag = () => {
  const tag = newTag.value.trim()
  if (tag && !selectedTags.value.includes(tag)) {
    selectedTags.value.push(tag)
    newTag.value = ''
  }
}

const addTag = (tag) => {
  if (!selectedTags.value.includes(tag)) {
    selectedTags.value.push(tag)
  }
}

const removeTag = (tag) => {
  const index = selectedTags.value.indexOf(tag)
  if (index > -1) {
    selectedTags.value.splice(index, 1)
  }
}

const saveLabels = async () => {
  isSaving.value = true
  try {
    console.log('保存标签:', selectedTags.value)
    showLabelModal.value = false
    newTag.value = ''
    emit('updateMediaFileList')
  } catch (error) {
    console.error('保存标签失败:', error)
  } finally {
    isSaving.value = false
  }
}

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!

const downloading = ref(false)

// 下载媒体
const downloadMedia = async () => {
  const media = currentMedia.value
  if (!media?.url) {
    message.warning('文件URL不存在，无法下载')
    return
  }

  if (downloading.value) return
  downloading.value = true

  if (media.file_type === 'mp4') {
    downloadMediaFile(workspaceId, media.file_id).then(res => {
      if (!res) {
        message.error('下载失败')
        return
      }
      const data = new Blob([res])
      downloadFile(data, media.name)
      message.info('下载成功')
    }).finally(() => {
      downloading.value = false
    })
  } else {
    downloadWatermarkMediaFile(media.file_id).then(res => {
      if (!res) {
        message.error('下载失败')
        return
      }
      const data = new Blob([res])
      downloadFile(data, media.name)
      message.info('下载成功')
    }).finally(() => {
      downloading.value = false
    })
  }
}

// 删除操作
const openDeleteModal = () => {
  showDeleteModal.value = true
}

const closeDeleteModal = () => {
  showDeleteModal.value = false
}

const confirmDelete = async () => {
  try {
    console.log('删除媒体文件')
    showDeleteModal.value = false
    emit('deleteMediaFile', currentMedia.value.id)
    closeMediaInfo()
  } catch (error) {
    console.error('删除媒体文件失败:', error)
  }
}

// 工具函数
const formatTime = (time) => {
  if (!time) return '--'
  try {
    return new Date(time).toLocaleString()
  } catch {
    return '--'
  }
}

const formatSize = (size) => {
  if (!size || size === 0) return '--'
  const mb = size / 1024 / 1024
  return mb.toFixed(2) + 'M'
}

const formatDuration = (duration) => {
  if (!duration) return '--'
  const minutes = Math.floor(duration / 60)
  const seconds = duration % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

const formatVideoTime = (time) => {
  if (!time || time <= 0) return '00:00'
  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time % 60)
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

const getImageTypeText = (current) => {
  return isPanorama.value ? '全景图' : current?.name ? (isImage(current) ? '普通图' : '视频') : '普通图'
}

const getMediaSrc = (media) => {
  if (!media) return ''
  if (isImage(media)) {
    return media.url || media.url
  }
  return media.abbreviation_url || media.url
}

const getThumbnailSrc = (media) => {
  if (!media) return ''
  if (media.panorama) {
    return media.url
  }
  if (!isImage(media)) {
    return 'data:image/png;base64,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'
  }
  return media.url || media.abbreviation_url
}

const getMediaType = (media) => {
  if (!media) return ''
  if (isImage(media)) {
    return media.panorama ? '全景图' : '图片'
  } else if (media.fileType === 4) {
    return '视频'
  }
  return '文件'
}

const getVideoMimeType = (media) => {
  if (!media || !media.file_type) return 'video/mp4'

  const typeMap = {
    mp4: 'video/mp4',
    webm: 'video/webm',
    ogg: 'video/ogg',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    wmv: 'video/x-ms-wmv'
  }

  return typeMap[media.file_type.toLowerCase()] || 'video/mp4'
}

const analysisChecked = ref(false)
const analysisLoading = ref(false)
const analysisUrl = ref('')
const analysisError = ref(false)
const analysisMessage = ref(false)
const analysisResults = ref([])

// 新增：计算属性，用于显示加载提示
const analysisTip = computed(() => {
  if (analysisLoading.value) {
    return '分析结果加载中...'
  }
  return '开启分析'
})

const showAnalysisImage = ref(false)

/* const handleAnalysisChange = async (checked) => {
  analysisChecked.value = checked
  analysisError.value = false
  analysisMessage.value = false
  showAnalysisImage.value = false

  if (checked) {
    // 切换到分析视图
    analysisLoading.value = true

    try {
      // 获取当前媒体的分析结果
      const media = currentMedia.value
      if (!media || !media.file_id) {
        throw new Error('无效的媒体文件')
      }

      // 获取分析图URL和分析结果
      const res = await getMediaFileAnalysis(media.file_id)

      // 检查返回的analysisUrl是否为null或空
      if (!res.data?.analysisUrl) {
        analysisError.value = true
        analysisMessage.value = true
      } else {
        analysisUrl.value = res.data.analysisUrl
        showAnalysisImage.value = true
        if (res.data.analysisResult) {
          try {
            // 如果返回的是字符串，解析为数组
            if (typeof res.data.analysisResult === 'string') {
              analysisResults.value = JSON.parse(res.data.analysisResult)
            } else {
              // 如果已经是数组，直接赋值
              analysisResults.value = res.data.analysisResult
            }
          } catch (error) {
            console.error('分析结果解析失败:', error)
            analysisResults.value = []
          }
        } else {
          analysisResults.value = []
        }
        await nextTick()
        updateImageViewer()
      }
    } catch (error) {
      console.error('获取分析图失败:', error)
      analysisError.value = true
      analysisMessage.value = true
    } finally {
      analysisLoading.value = false
    }
  } else {
    // 关闭分析视图，重置状态
    analysisUrl.value = ''
    analysisResults.value = []
    analysisMessage.value = false
    analysisError.value = false
    showAnalysisImage.value = false
    await nextTick()
    updateImageViewer()
  }
} */

const updateImageViewer = () => {
  // 销毁现有的查看器
  if (viewerInstance.value) {
    viewerInstance.value.destroy()
    viewerInstance.value = null
  }

  // 重新初始化查看器
  initImageViewer()
}

// 新增：关闭分析结果弹框
const closeAnalysisResults = () => {
  analysisChecked.value = false
  analysisUrl.value = ''
  analysisResults.value = []
  analysisMessage.value = false
  analysisError.value = false
  showAnalysisImage.value = false
}

// 算法分析弹窗相关
const algoMediaAnalysisVisible = ref(false)
const submitAlgoAnalysisLoading = ref(false)
const submitAlgoAnalysisFileId = ref('')
const isFromPreview = ref(false) // 区分来源：预览开关还是文件分析按钮
const algorithmDataList = ref<any[]>([])

const formAlgoAnalysisData = ref({
  algorithmId: null,
  confidence: 0.5,
  enableLargeModel: 0
})

async function loadAlgorithmList () {
  try {
    const res = await getAllAlgList({})
    if (res && res.code === 200) {
      algorithmDataList.value = res.data || []
    }
  } catch (error) {
    console.error('加载算法列表失败', error)
  }
}

const loadAnalysisImageForCurrent = async () => {
  const media = currentMedia.value
  if (!media || !media.file_id) return false
  analysisLoading.value = true
  analysisError.value = false
  analysisMessage.value = false
  try {
    const res = await getMediaFileAnalysis(media.file_id)
    if (!res.data?.analysisUrl) {
      analysisError.value = true
      analysisMessage.value = true
      return false
    } else {
      analysisUrl.value = res.data.analysisUrl
      showAnalysisImage.value = true
      if (res.data.analysisResult) {
        try {
          analysisResults.value = typeof res.data.analysisResult === 'string'
            ? JSON.parse(res.data.analysisResult)
            : res.data.analysisResult
        } catch {
          analysisResults.value = []
        }
      } else {
        analysisResults.value = []
      }
      await nextTick()
      updateImageViewer()
      return true
    }
  } catch (error) {
    console.error('获取分析图失败:', error)
    analysisError.value = true
    analysisMessage.value = true
    return false
  } finally {
    analysisLoading.value = false
  }
}

const handleAnalysisChange = async (checked: boolean) => {
  if (!checked) {
    // 关闭开关：隐藏分析图，清空结果
    analysisChecked.value = false
    analysisUrl.value = ''
    analysisResults.value = []
    analysisMessage.value = false
    analysisError.value = false
    showAnalysisImage.value = false
    await nextTick()
    updateImageViewer()
    return
  }

  // 开启开关
  const media = currentMedia.value
  if (!media || !media.file_id) {
    analysisChecked.value = false
    return
  }

  // 检查是否已有分析结果
  const hasAnalysisResult = (() => {
    const result = media.analysis_result
    if (!result) return false
    if (typeof result === 'string') {
      return result !== '' && result !== '{}'
    }
    if (Array.isArray(result)) {
      return result.length > 0
    }
    if (typeof result === 'object') {
      return Object.keys(result).length > 0
    }
    return false
  })()

  if (hasAnalysisResult) {
    // 已有分析结果，直接加载显示
    analysisChecked.value = true
    if (media.analysis_url) {
      analysisUrl.value = media.analysis_url
      showAnalysisImage.value = true
      if (media.analysis_result) {
        try {
          analysisResults.value = typeof media.analysis_result === 'string'
            ? JSON.parse(media.analysis_result)
            : media.analysis_result
        } catch {
          analysisResults.value = []
        }
      }
      await nextTick()
      updateImageViewer()
    } else {
      await loadAnalysisImageForCurrent()
    }
  } else {
    // 无分析结果，弹出算法选择弹窗
    isFromPreview.value = true
    submitAlgoAnalysisFileId.value = media.file_id
    // 重置表单默认值
    formAlgoAnalysisData.value = {
      algorithmId: null,
      confidence: 0.5,
      enableLargeModel: 0
    }
    algoMediaAnalysisVisible.value = true
    // 保持 analysisChecked 为 false，等待分析成功后再设置
    analysisChecked.value = false
  }
}

const toggleAlgoAnalysis = async () => {
  submitAlgoAnalysisLoading.value = true
  try {
    const res = await getAlgoAnalysisResult(
      submitAlgoAnalysisFileId.value,
      formAlgoAnalysisData.value.confidence,
      formAlgoAnalysisData.value.algorithmId,
      formAlgoAnalysisData.value.enableLargeModel
    )
    if (res.code === 0) {
      message.success('分析成功')
      // 更新当前媒体对象的分析结果字段，以便下次直接使用
      if (res.data) {
        if (res.data.analysisUrl) {
          currentMedia.value.analysis_url = res.data.analysisUrl
        }
        if (res.data.analysisResult) {
          currentMedia.value.analysis_result = res.data.analysisResult
        }
      }
      if (isFromPreview.value) {
        algoMediaAnalysisVisible.value = false
        analysisChecked.value = true
        await loadAnalysisImageForCurrent()
      }
    } else {
      message.error(res.message || '分析失败')
      if (isFromPreview.value) {
        analysisChecked.value = false
      }
    }
  } catch (error) {
    message.error('分析失败')
    if (isFromPreview.value) {
      analysisChecked.value = false
    }
  } finally {
    submitAlgoAnalysisLoading.value = false
    if (!isFromPreview.value) {
      algoMediaAnalysisVisible.value = false
    }
    isFromPreview.value = false
  }
}

const handleCloseAlgoMediaAnalysis = () => {
  algoMediaAnalysisVisible.value = false
  if (isFromPreview.value) {
    analysisChecked.value = false
    isFromPreview.value = false
  }
  submitAlgoAnalysisLoading.value = false
  formAlgoAnalysisData.value.algorithmId = null
  formAlgoAnalysisData.value.confidence = 0.5
  formAlgoAnalysisData.value.enableLargeModel = 0
}

const modelChecked = ref(false)
const modelModalVisible = ref(false)

// 隐患识别开关变化
const handleModelChange = (checked: boolean) => {
  if (checked) {
    modelModalVisible.value = true
  } else {
    modelModalVisible.value = false
  }
}

watch(modelModalVisible, (val) => {
  if (!val) {
    modelChecked.value = false
  }
})

const onAnalysisSaved = async () => {
  emit('updateMediaFileList')
}

// 组件生命周期
onMounted(() => {
  // 监听全屏变化
  document.addEventListener('fullscreenchange', () => {
    isFullscreen.value = !!document.fullscreenElement
  })
  loadAlgorithmList()
})

onUnmounted(() => {
  destroyPanoramaViewer()
  destroyImageViewer()
  document.removeEventListener('fullscreenchange', () => { })
})

// 暴露给父组件的方法
defineExpose({
  initData
})
</script>

<style lang="scss" scoped>
.media-info-com {
  display: flex;
  width: 100%;
  height: calc(100% - 60px);
  background: #001529;
  position: absolute;

  /* 左侧区域 */
  .m-i-c-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    border-right: 1px solid #303030;
    overflow: hidden;

    .media-name {
      padding: 16px 24px;
      border-bottom: 1px solid #303030;
      flex-shrink: 0;
      background: #1f1f1f;

      .m-n-info1 {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 6px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .m-n-info2 {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.65);

        i {
          font-size: 14px;
        }
      }
    }

    /* 切换按钮 */
    .media-left-btn,
    .media-right-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.15);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
        border-color: rgba(255, 255, 255, 0.25);
        transform: translateY(-50%) scale(1.05);
      }

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }

    .media-left-btn {
      left: 16px;
    }

    .media-right-btn {
      right: 16px;

      &.media-right-btn-full {
        right: 32px;
      }
    }

    .load-mask {
      position: absolute;
      left: -1%;
      top: -1%;
      z-index: 110;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 102%;
      height: calc(100% - 44px);
    }
    .load-mask-bg{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 164px);
      z-index: 109;
      background-color: rgba(0, 0, 0, 0.5);
    }

    /* 媒体内容区域 */
    .media-content {
      flex: 1;
      position: relative;
      overflow: hidden;
      background: #000000;

      /* 全景图容器 */
      #panorama {
        width: 100%;
        height: 100%;
        position: relative;

        :deep(.psv-navbar) {
          display: none !important;
        }
      }

      /* 图片查看器 */
      .imgViewer-com {
        width: 100%;
        height: calc(100% - 164px);
        position: relative;

        &.imgViewer-com-full {
          width: 100%;
          height: 100%;
          z-index: 1000;

          :deep(.viewer-container) {
            width: 100% !important;
            height: 100% !important;
          }
        }

        #imgViewer {
          width: 100%;
          height: 100%;
          position: relative;
          overflow: hidden;

          ul {
            display: flex;
            list-style: none;
            padding: 0;
            margin: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;

            li {
              flex: 0 0 100%;
              width: 100%;
              height: 100%;
              position: relative;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                display: none;
              }
            }
          }
        }
      }

      /* 视频查看器 */
      .videoViewer-com {
        width: 100%;
        height: 100%;
        position: relative;

        &.videoViewer-com-full {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 1000;
        }

        .video-player {
          width: 100%;
          height: 100%;
          background: #000000;
          outline: none;
        }
      }

      /* 视频进度条 */
      .video-progress-container {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 0 16px 16px;

        .video-progress-bar {
          flex: 1;
          height: 4px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 2px;
          cursor: pointer;
          position: relative;

          &:hover {
            height: 6px;

            .video-progress-handle {
              display: block;
            }
          }

          .video-progress {
            height: 100%;
            background: #1890ff;
            border-radius: 2px;
            transition: width 0.1s ease;
          }

          .video-progress-handle {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 12px;
            height: 12px;
            background: #1890ff;
            border-radius: 50%;
            display: none;
          }
        }

        .video-time {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          min-width: 80px;
          text-align: right;
        }
      }
      .total-page-box{
        position: absolute;
        width: 100%;
        z-index: 6;
        height: 35px;
        .total-page-num{
          position: absolute;
          bottom: 0;
          left: 38%;
          color: #ffffff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 35px;
        }
        .total-page-size{
          position: absolute;
          bottom: 0;
          right: 37.5%;
          color: #ffffff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 35px;
        }
      }
      /* 操作区域 */
      .media-operate {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
        padding: 16px 0;
        z-index: 5;

        &.media-operate-full {
          position: fixed;
          bottom: 0;
          z-index: 1001;
          background: rgba(0, 0, 0, 0.9);
        }

        /* 操作按钮列表 */
        .m-o-btn-list {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-bottom: 16px;
          padding: 0 16px;
          position: relative;
          z-index: 10;

          .btn-li {
            width: 36px;
            height: 36px;
            border-radius: 6px;
            color: #fff;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.2);
              transform: translateY(-1px);
            }

            i {
              font-size: 18px;
              color: #ffffff;
            }
          }
        }

        /* 缩略图列表 */
        .m-o-img-list {
          width: 100%;
          padding: 0 16px;
          display: flex;
          align-items: center;
          justify-content: center;

          .media-left-btn,
          .media-right-btn {
            position: relative;
            top: 20px;
            left: 16px;
          }

          .media-left-btn {
            left: -16px;
          }

          .img-list-content {
            display: flex;
            gap: 8px;
            justify-content: center;
            padding: 4px 0;
            width: auto;
            overflow-x: auto;
          }

          .img-preview {
            width: 84px;
            height: 72px;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
            position: relative;
            border: 2px solid transparent;
            flex-shrink: 0;
            transition: all 0.2s ease;

            &:hover {
              transform: translateY(-2px);
              border-color: rgba(24, 144, 255, 0.3);
            }

            &.active {
              border-color: #1890ff;
              box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
            }

            &.panorama-preview {
              border-color: #52c41a;

              &.active {
                border-color: #52c41a;
                box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
              }
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .img-tips {
              position: absolute;
              bottom: 2px;
              right: 2px;
              background: rgba(0, 0, 0, 0.5);
              color: #fff;
              font-size: 12px;
              padding: 1px 3px;
              border-radius: 2px;
            }

            .panorama-badge {
              position: absolute;
              top: 4px;
              left: 4px;
              background: rgba(82, 196, 26, 0.8);
              border-radius: 2px;
              padding: 1px 4px;

              i {
                font-size: 12px;
                color: white;
              }
            }
          }
        }
      }
    }
  }

  /* 右侧区域 */
  .m-i-c-right {
    width: 400px;
    display: flex;
    flex-direction: column;
    background: #1f1f1f;
    position: relative;

    /* 关闭按钮 */
    .m-i-c-close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: rotate(90deg);
      }

      i {
        font-size: 16px;
        color: #ffffff;
      }
    }

    /* 详细信息区域 */
    .detail-info {
      flex: 1;
      overflow-y: auto;
      padding: 20px 24px;

      .d-i-title {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 20px;
        padding-bottom: 12px;
        border-bottom: 1px solid #303030;
      }

      /* 数据列表 */
      .d-i-dataList {
        display: flex;
        margin-bottom: 16px;

        .dataList-key {
          width: 80px;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.65);
          flex-shrink: 0;
          padding-top: 2px;
        }

        .dataList-val {
          flex: 1;
          font-size: 13px;
          color: #ffffff;
          word-break: break-word;
          line-height: 1.5;

          &.d-a-name {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .name {
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-right: 8px;
            }

            .name-edit-btn {
              flex-shrink: 0;
              display: flex;
              gap: 4px;
              cursor: pointer;

              i {
                font-size: 16px;
                transition: color 0.2s ease;

                &:hover {
                  opacity: 0.8;
                }
              }

              .icon_edit {
                color: #1890ff;
              }

              .icon_check {
                color: #52c41a;
              }

              .icon_close {
                color: #ff4d4f;
              }
            }

            .name-input {
              flex: 1;
              padding: 4px 8px;
              border: 1px solid #1890ff;
              border-radius: 4px;
              background: rgba(0, 0, 0, 0.2);
              color: #ffffff;
              font-size: 13px;

              &:focus {
                outline: none;
                border-color: #40a9ff;
              }
            }
          }
        }
      }

      /* 标签样式 */
      .icon-tag-item {
        display: inline-block;
        padding: 2px 8px;
        background: rgba(24, 144, 255, 0.1);
        border: 1px solid rgba(24, 144, 255, 0.3);
        border-radius: 12px;
        font-size: 12px;
        color: #1890ff;
        margin-right: 6px;
        margin-bottom: 6px;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(24, 144, 255, 0.2);
        }
      }

      .no-tag {
        color: rgba(255, 255, 255, 0.45);
        font-style: italic;
      }

      /* 操作按钮区域 */
      .detail-btn {
        display: flex;
        gap: 12px;
        margin-top: 24px;
        padding-top: 20px;
        border-top: 1px solid #303030;

        .d-b-li {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          padding: 12px 0;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            transform: translateY(-2px);
            border-color: rgba(255, 255, 255, 0.2);
          }

          &:active {
            transform: translateY(0);
          }

          i {
            font-size: 20px;
            color: #ffffff;
          }

          .btn-txt {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
            font-weight: 500;
          }
        }
      }
    }
  }

  /* 模态框样式 */
  .label-modal-overlay,
  .delete-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    animation: fadeIn 0.2s ease-out;
  }

  .label-modal {
    width: 480px;
    max-width: 90vw;
    max-height: 80vh;
    background: #001529;
    border-radius: 8px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 24px;
      border-bottom: 1px solid #303030;

      .modal-title {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
      }

      .btn-close {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.15);
        background: rgba(255, 255, 255, 0.05);
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.25);
          color: #ffffff;
        }

        i {
          font-size: 16px;
        }
      }
    }

    .modal-content {
      flex: 1;
      overflow-y: auto;
      padding: 24px;
    }

    .modal-footer {
      display: flex;
      gap: 12px;
      padding: 20px 24px;
      border-top: 1px solid #303030;
    }

    .btn {
      flex: 1;
      height: 36px;
      border-radius: 6px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;

      &-cancel {
        background: rgba(255, 255, 255, 0.05);
        color: rgba(255, 255, 255, 0.7);

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #ffffff;
        }
      }

      &-save {
        background: #1890ff;
        color: #ffffff;

        &:hover:not(:disabled) {
          background: #40a9ff;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }

  .delete-modal {
    width: 400px;
    max-width: 90vw;
    padding: 32px;
    background: #001529;
    border-radius: 8px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    text-align: center;
    animation: scaleIn 0.3s ease-out;

    .modal-icon {
      width: 60px;
      height: 60px;
      margin: 0 auto 20px;
      background: rgba(255, 77, 79, 0.1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid rgba(255, 77, 79, 0.3);

      i {
        font-size: 28px;
        color: #ff4d4f;
      }
    }

    .modal-title {
      margin: 0 0 12px 0;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
    }

    .modal-message {
      margin: 0 0 8px 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.5;

      .media-name {
        color: #1890ff;
        font-weight: 500;
      }
    }

    .modal-warning {
      margin: 0 0 24px 0;
      font-size: 13px;
      color: #ff4d4f;
    }

    .modal-actions {
      display: flex;
      gap: 12px;

      .btn {
        flex: 1;
        height: 36px;
        border-radius: 6px;
        border: none;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;

        &-cancel {
          background: rgba(255, 255, 255, 0.05);
          color: rgba(255, 255, 255, 0.7);
          border: 1px solid rgba(255, 255, 255, 0.15);

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border-color: rgba(255, 255, 255, 0.25);
          }
        }

        &-delete {
          background: #ff4d4f;
          color: #ffffff;

          &:hover {
            background: #ff7875;
          }
        }
      }
    }
  }
}

.analysis-float-layer {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 20;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  min-width: 160px;

  .analysis-switch {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .analysis-label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.9);
    }

    :deep(.ant-switch) {
      background-color: rgba(255, 255, 255, 0.3);

      &.ant-switch-checked {
        background-color: #1890ff;
      }
    }
  }

  .analysis-results-popup {
    max-height: 300px;
    overflow-y: auto;

    .analysis-results-header {
      padding: 10px 15px;
      background: rgba(0, 0, 0, 0.8);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 14px;

      .close-icon {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;

        &:hover {
          color: white;
        }
      }
    }

    .analysis-loading {
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .analysis-results-content {
      padding: 12px 15px;

      .analysis-items {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .analysis-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);

          &:last-child {
            border-bottom: none;
          }

          .analysis-name {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.9);
          }

          .analysis-count {
            font-size: 14px;
            font-weight: 600;
            color: #52c41a;
          }
        }
      }

      .no-analysis-results,
      .analysis-error {
        padding: 15px 0;
        text-align: center;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.8);
      }

      .analysis-error {
        color: #ff4d4f;
      }
    }
  }
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .media-info-com {
    .m-i-c-right {
      width: 350px;
    }
  }
}

@media (max-width: 992px) {
  .media-info-com {
    flex-direction: column;

    .m-i-c-left {
      height: 60vh;
      border-right: none;
      border-bottom: 1px solid #303030;
    }

    .m-i-c-right {
      width: 100%;
      height: 40vh;
    }
  }
}

@media (max-width: 768px) {
  .media-info-com {
    .m-i-c-left {
      .media-name {
        padding: 12px 16px;
      }

      .media-left-btn,
      .media-right-btn {
        width: 36px;
        height: 36px;

        i {
          font-size: 18px;
        }
      }

      .media-operate {
        .m-o-btn-list {
          padding: 0 12px;

          .btn-li {
            width: 32px;
            height: 32px;

            i {
              font-size: 16px;
            }
          }
        }

        .m-o-img-list {
          padding: 0 12px;

          .img-preview {
            width: 70px;
            height: 60px;
          }
        }
      }
    }

    .m-i-c-right {
      .detail-info {
        padding: 16px;

        .d-i-dataList {
          flex-direction: column;
          gap: 4px;
          margin-bottom: 12px;

          .dataList-key {
            width: 100%;
          }
        }

        .detail-btn {
          flex-wrap: wrap;
          gap: 8px;

          .d-b-li {
            flex: 0 0 calc(50% - 4px);
            padding: 10px 0;

            i {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .media-info-com {
    .m-i-c-left {
      height: 50vh;
    }

    .m-i-c-right {
      height: 50vh;
    }

    .label-modal,
    .delete-modal {
      width: 95vw;
    }
  }
}

.algo-analysis-form {
  padding: 16px 8px;

  .form-item {
    margin-bottom: 24px;

    .form-label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .form-control {
      width: 100%;

      :deep(.ant-select) {
        width: 100%;
      }

      :deep(.ant-input-number) {
        width: 100%;
      }
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }
}
</style>
